<template>
  <section class="hero-section">
    <div class="container">
      <div class="hero-content">
        <h1 class="hero-title">
          Claude Code 代码助手<br>
          <span class="gradient-text">国内稳定镜像服务</span>
        </h1>
        <p class="hero-subtitle">
          🚀 无需梯子，国内稳定访问！GAC Code 提供 Claude Code 官方镜像服务，采用积分制度和智能回血机制，让您享受更稳定、更经济的 AI 编程体验。
        </p>
        <div class="hero-features">
          <div class="feature-tag">🌐 国内镜像</div>
          <div class="feature-tag">🔄 积分回血</div>
          <div class="feature-tag">💰 超值价格</div>
          <div class="feature-tag">🛠️ 工单重置</div>
        </div>
        <div class="hero-buttons">
          <a href="#pricing" class="btn btn-primary">查看套餐对比</a>
          <button class="btn btn-secondary" @click="navigateToQuickStart">
            快速入门
          </button>
        </div>
        <div class="hero-stats">
          <div class="stat">
            <span class="stat-number">1000万+</span>
            <span class="stat-label">代码行数生成</span>
          </div>
          <div class="stat">
            <span class="stat-number">5万+</span>
            <span class="stat-label">活跃开发者</span>
          </div>
          <div class="stat">
            <span class="stat-number">99.9%</span>
            <span class="stat-label">服务稳定性</span>
          </div>
        </div>
      </div>
      <div class="hero-visual">
        <div class="code-window">
          <div class="window-header">
            <div class="window-controls">
              <span class="control close"></span>
              <span class="control minimize"></span>
              <span class="control maximize"></span>
            </div>
            <span class="window-title">Claude Code</span>
          </div>
          <div class="code-content">
            <div class="code-line">
              <span class="prompt">$</span>
              <span class="command">claude-code</span>
              <span class="text">帮我实现一个用户管理系统</span>
            </div>
            <div class="code-line response">
              <span class="ai-indicator">🤖</span>
              <span class="text">正在分析您的项目结构，为您创建用户管理系统...</span>
            </div>
            <div class="code-line response">
              <span class="created">✅ 已创建</span>
              <span class="file">api/routes/users.js</span>
            </div>
            <div class="code-line response">
              <span class="created">✅ 已创建</span>
              <span class="file">components/UserManager.vue</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'HeroSection',
  inject: ['setCurrentPage'],
  methods: {
    navigateToQuickStart() {
      this.setCurrentPage('quick-start');
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  }
}
</script>

<style scoped>
.hero-section {
  padding: 140px 0 120px;
  background: #fafafa;
  position: relative;
  overflow: hidden;
}

.hero-section::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: radial-gradient(circle at 50% 20%, rgba(15, 15, 35, 0.03) 0%, transparent 50%);
}

.container {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 80px;
  align-items: center;
  position: relative;
  z-index: 1;
}

.hero-title {
  font-size: 3.5rem;
  font-weight: 700;
  line-height: 1.1;
  margin-bottom: 24px;
  color: #0f0f23;
  letter-spacing: -0.02em;
}

.gradient-text {
  color: #6b7280;
}

.hero-subtitle {
  font-size: 1.125rem;
  line-height: 1.6;
  color: #6b7280;
  margin-bottom: 40px;
  max-width: 600px;
}

.hero-features {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  margin-bottom: 32px;
}

.feature-tag {
  background: #f3f4f6;
  border: 1px solid #e5e7eb;
  color: #374151;
  padding: 6px 12px;
  border-radius: 6px;
  font-size: 0.75rem;
  font-weight: 500;
}

.hero-buttons {
  display: flex;
  gap: 16px;
  margin-bottom: 60px;
}

.hero-stats {
  display: flex;
  gap: 40px;
}

.stat {
  display: flex;
  flex-direction: column;
}

.stat-number {
  font-size: 2rem;
  font-weight: 700;
  color: #1e293b;
  margin-bottom: 4px;
}

.stat-label {
  font-size: 0.875rem;
  color: #64748b;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

.hero-visual {
  display: flex;
  justify-content: center;
  align-items: center;
}

.code-window {
  background: #1e293b;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 25px 50px rgba(0, 0, 0, 0.25);
  width: 100%;
  max-width: 500px;
}

.window-header {
  background: #334155;
  padding: 12px 16px;
  display: flex;
  align-items: center;
  gap: 12px;
}

.window-controls {
  display: flex;
  gap: 6px;
}

.control {
  width: 12px;
  height: 12px;
  border-radius: 50%;
}

.control.close {
  background: #ef4444;
}

.control.minimize {
  background: #f59e0b;
}

.control.maximize {
  background: #10b981;
}

.window-title {
  color: #94a3b8;
  font-size: 0.875rem;
  font-weight: 500;
}

.code-content {
  padding: 20px;
  font-family: 'SF Mono', Monaco, 'Cascadia Code', 'Roboto Mono', Consolas, 'Courier New', monospace;
  font-size: 0.875rem;
  line-height: 1.6;
}

.code-line {
  display: flex;
  align-items: center;
  margin-bottom: 8px;
}

.prompt {
  color: #10b981;
  margin-right: 8px;
}

.command {
  color: #3b82f6;
  margin-right: 8px;
}

.text {
  color: #e2e8f0;
}

.response .text {
  color: #94a3b8;
  margin-left: 8px;
}

.ai-indicator {
  margin-right: 8px;
}

.created {
  color: #10b981;
  margin-right: 8px;
}

.file {
  color: #f59e0b;
}

@media (max-width: 768px) {
  .container {
    grid-template-columns: 1fr;
    gap: 40px;
    text-align: center;
  }
  
  .hero-title {
    font-size: 2.5rem;
  }
  
  .hero-stats {
    justify-content: center;
  }
}
</style>